<!--
    upimage_logo
    画像アップロードのコンポーネント
    基本的な動作
    ・Storageへのアップロードとリサイズ
    ・アップロード先URLの返却
    親コンポーネントで必要な変更は次ブロックを参考
    ideaImageForEditは、編集時に古い画像を表示できるように
-->
<template>
  <div class="contents d-flex flex-column ml-2">
    <!-- <img class="camera" src="../assets/camera.svg" /> -->
    <v-btn
      v-if="isAdmin"
      class="mx-auto my-2"
      color="#707070"
      rounded
      width="150"
    >
      <label class="input-item__label" >
        <v-icon color="#FFFFFF" size="19">mdi-camera </v-icon>
        画像を追加
        <input type="file" @change="onFileChange" />
      </label>
    </v-btn>
    <v-btn
      v-if="isAdmin&&ideaImageForEdit!=='none'"
      class="mx-auto"
      color="#707070"
      rounded @click="removeimage"
      width="150"
    >
      <label class="input-item__label" >
        <v-icon color="#FFFFFF" size="19">mdi-camera </v-icon>
        画像を削除
      </label>
    </v-btn>
  </div>
</template>
 
<script>
import firebase from "firebase";
import Compressor from "compressorjs";


export default {
  name: "upImage",
  props: ['ideaImageForEdit'],
  data() {
    return {
    };
  },
  methods: {
    emit2pt(filename, isSum) {
      if(isSum==="all"||isSum==="true") {
        firebase.firestore().collection("0").doc("config").set({
          logo_sum: filename
        },{merge:true});        
      }
      if(isSum==="all"||isSum==="false") {
        firebase.firestore().collection("0").doc("config").set({
          logo: filename
        },{merge:true});
        //console.log("logo",filename)
      }
      this.$store.dispatch('getLogoSrc', filename);
    },
    myConsole(msg) {//一括削除できるように
      //console.log(msg);
    },
    onFileChange(e) {
      this.myConsole("onFileChange");
      const files = e.target.files || e.dataTransfer.files;
      //StorageにUP
      this.resizeImg(files[0]);
      this.originImg(files[0]);
    },
    removeimage() {
      this.emit2pt("none", "all");
    },
    //画像のアップロード
    resizeImg(file) {
      let self = this;
      let filename = this.today() + "-sum.jpeg";
      const payload = {
        quality: 0.9,
        maxWidth: 100,
        maxHeight: 100,
        mimeType: "image/jpeg",
        success(blob) {
          var reader = new FileReader();
          reader.onloadend = () => {
            const result = reader.result;
            if (result instanceof ArrayBuffer || result === null) return;
            self.upImg2Storage(result, filename, "true");
          };
          reader.readAsDataURL(blob);
        },
        error(err) {
          //console.log(err.message);
        },
      };
      new Compressor(file, payload);
    },
    originImg(file) {
      let self = this;
      let filename = this.today() + ".jpeg";
      const payload = {
        quality: 0.8,
        mimeType: "image/jpeg",
        success(blob) {
          var reader = new FileReader();
          reader.onloadend = () => {
            const result = reader.result;
            if (result instanceof ArrayBuffer || result === null) return;
            self.upImg2Storage(result, filename, "false");
          };
          reader.readAsDataURL(blob);
        },
        error(err) {
          //console.log(err.message);
        },
      };
      new Compressor(file, payload);
    },
    upImg2Storage(file, filename, isSum) {
      // Create the file metadata
      const metadata = {
        contentType: "image/jpeg",
      };

      // Upload file and metadata to the object 'images/mountains.jpg'
      const uploadTask = firebase.storage().ref()
        .child("logo/" + filename)
        .putString(file, "data_url");

      // Listen for state changes, errors, and completion of the upload.
      uploadTask.on(
        "state_changed", // or 'state_changed'
        (snapshot) => {
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          this.myConsole("Upload is " + progress + "% done");
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              this.myConsole("Upload is paused");
              break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
              this.myConsole("Upload is running");
              break;
          }
        },
        (error) => {
          switch (error.code) {
            case "storage/unauthorized":
              break;
            case "storage/canceled":
              break;
            case "storage/unknown":
              break;
          }
        },
        () => {
          // Upload completed successfully, now we can get the download URL
          let filenameRef = "logo/" + filename;
          firebase.storage().ref().child(filenameRef).getDownloadURL().then((downloadURL) => {
            this.emit2pt(downloadURL, isSum);
            return downloadURL;
          });
        }
      );
    },
    toDoubleDigits(num) {
        num += "";
        if (num.length === 1) {
          num = "0" + num;
        }
      return num; 
    },
    today(){
      // 日付をYYYY/MM/DD HH:DD:MI:SS形式で取得
      let date = new Date();
      let yyyy = date.getFullYear();
      let mm = this.toDoubleDigits(date.getMonth() + 1)
      let dd = this.toDoubleDigits(date.getDate())
      let hh = this.toDoubleDigits(date.getHours())
      let mi = this.toDoubleDigits(date.getMinutes())
      let se = this.toDoubleDigits(date.getSeconds())
      let ms = this.toDoubleDigits(date.getMilliseconds())
      if(ms.length==2) ms = "0"+ms
      return yyyy + mm + dd + hh + mi + se + ms
    }
  },
  computed: {
    isAdmin(){
      return this.$store.state.isAdmin
    }
  },
};
</script>
<style scoped>
.contents > .camera {
  cursor: pointer;
}
.input-item__label {
  cursor: pointer;
  color:#FFFFFF;
}
.input-item__label input[type="file"] {
  display: none;
}
.camera {
  width: 20px;
}
</style>